import styled from "styled-components"

const DiagnosisContainer = styled.div`
  position: relative;
  box-sizing: border-box;
  align-items: center;
  text-align: left;
  display: flex;
  flex-direction: column;
`

export { DiagnosisContainer as default }


// WEBPACK FOOTER //
// ./assets/completion/components/DiagnosisContainer.js